


















































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component<UserFilter>({})
export default class UserFilter extends Vue {
  @Prop({ type: Number })
  companyId: number;

  @Prop({ type: Number })
  groupId: number;

  @Prop({ type: String })
  search: string;

  get groupEndpoint() {
    if (this.companyId) {
      return `/group?filter=companyId||$eq||${this.companyId}`;
    }
    return '/group';
  }
}
